import React from 'react';
import './home.css'
import './../animations.css'

import heroimg1 from './../assets/heroimg02.png'
import arrow1 from './../assets/arrow.svg'
import b7 from '../assets/whhyicon1.svg'
import b8 from "../assets/whychoose2.png"
import b9 from "../assets/whychoose3.png"
import sec3img from "../assets/s3img.png"
import propertyimg1 from "./../assets/cardimg01.jpg"
import propertyimg2 from "./../assets/cardimg02.jpg"
import propertyimg3 from "./../assets/cardimg03.jpg"

import logo1 from "./../assets/sliderimg01.png"
import logo2 from "./../assets/sliderimg02.png"
import logo3 from "./../assets/sliderimg03.png"
import logo4 from "./../assets/sliderimg04.png"
import logo5 from "./../assets/sliderimg05.png"
import logo6 from "./../assets/sliderimg06.png"

import Navbar from '../components/farh/layout/nav';
import Stat from './../components/farh/common/herofloat';
import SecHead from '../components/farh/layout/secHeading';
import Whychoose from '../components/janna/common/whychoose';
import Button1 from '../components/farh/common/button';
import BodyTxt from '../components/farh/common/body';
import Footer from '../components/janna/layout/footer';
import Property from '../components/farh/common/property';
import Logo from '../components/farh/common/crouselLogo';

const Home = () => {
    return ( <>
        <Navbar/>
        <main>
            <section>
                <div className="container hero">
                    <h1 className='fadeIn'>
                Your new <span>home</span> is with us.
            </h1>
                    <div className="heroimg1 floatIn">
                        <img  src={heroimg1} alt="" />
                        <div></div>
                    </div>                    
                    <Stat num="87+" title="Original Sites" style1="stat1" />
                    <Stat num="25" title="Installations" style1="stat2" />
                    <div className="carousel-wrapper">
                        <div className="blurred_separator">
                        </div>
                        <div className=" blurred_separator2">
                        </div>
                        <div className="carousel" id="carousel">
                            <Logo logo={logo1} />
                            <Logo logo={logo2} />
                            <Logo logo={logo3} />
                            <Logo logo={logo4} />
                            <Logo logo={logo5} />
                            <Logo logo={logo6} />
                            <Logo logo={logo1} />
                            <Logo logo={logo2} />
                            <Logo logo={logo3} />
                            <Logo logo={logo4} />
                            <Logo logo={logo5} />
                            <Logo logo={logo6} />
                            <Logo logo={logo1} />
                        </div>
                    </div>
                <Button1 className="heroBtn" style2="btn1"  cta="Start Exploring" icon={arrow1} />
                </div>
                
            </section>
            {/* 2 */}
            <section>
               <div className='whychooseussec'>
                 <div className="container">
                    <SecHead style3='secHeading1' title='Why choose us?' sub1="The real deal." sub2="Explore handpicked residential and commercial projects across Egypt." />   
                </div>
                <div className='whychooseusdiv1'>
                        <Whychoose 
                        whyicon ={b7}
                        whytitle="Excellence"
                        whyp="We are committed to delivering unmatched craftsmanship and precision in every project we undertake."
                        />
                         <Whychoose 
                        whyicon ={b8}
                        whytitle="Personalization"
                        whyp="We are committed to delivering unmatched craftsmanship and precision in every project we undertake."
                        />
                         <Whychoose 
                        whyicon ={b9}
                        whytitle="Sustainability"
                        whyp="We are committed to delivering unmatched craftsmanship and precision in every project we undertake."
                        />
                    </div>
               </div>
            </section>
            {/* 3 */}
            <section>
               <div className="container homeSec3">
                   <div className="left">
                     <SecHead style3='secHeading2' title='Designed for Elevated Living.' sub1="About us" sub2="Make your life easier with Egyrealty" />  
                    <BodyTxt text="We specialize in connecting investors and homeowners with high-value properties that combine architectural integrity, strategic location, and long-term growth potential." /> 
                    <BodyTxt text="With over a decade of experience in Egypt's real estate market, we've helped thousands of clients find their dream homes and make smart investment decisions." /> 
        <Button1 icon={arrow1} style2="primarySmall" cta="Start Exploring" />
                   </div>
                   <img className='sec3img' src={sec3img} alt="" />
                </div>
            </section>
            {/* 4 */}
             <section>
               <div className='whychooseussec'>
                 <div className="container ">
                    <SecHead style3='secHeading1' title='Featured Developments' sub1="Curated Selection" sub2="Explore handpicked residential and commercial projects across Egypt." />   
                </div>
                <div className='whychooseusdiv1 moveIn scrollAnimate'>
                    {/* 1 */}
                        <Property
                        img={propertyimg1} 
                        location="New Cairo" 
                        title="Palm Hills New Cairo" 
                        price="3,500,000" 
                        statustype="status1" 
                        statustxt="Ready to Move" 
                        />
                        {/* 2 */}
                        <Property 
                        img={propertyimg2} 
                        location="Sheikh Zayed" 
                        title="Zed West Residence" 
                        price="4,200,000" 
                        statustype="status2" 
                        statustxt="Under Construction" 
                        />

                        {/* 3 */}
                        <Property 
                        img={propertyimg3} 
                        location="6th of October" 
                        title="Mountain View iCity" 
                        price="2,850,000" 
                        />
                    </div>
                    <Button1 className="heroBtn" style2="btn1"  cta="Start Exploring" icon={arrow1} />

               </div>
            </section>
        </main>
        <Footer />
    </> );
}
 
export default Home;